<div *ngIf="cogs$ | async as cogs">
    <div class="report-page" id="report-page" >
        <kendo-pdf-export #pdf paperSize="A4" margin=".5cm" [scale]="scale" [fileName]='getPDFFilename()'
            [keepTogether]="keepTogether" forcePageBreak=".page-break">
            <div class="pdf">
                <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="pdfFooter">
                        <div class="pageNum">Page {{ pageNum }} of {{ totalPages }}</div>
                        <div class="version">RTA - Order v3.0.05192025</div>
                        <div class="printDate">Date printed: {{printcurrentDate_String}}</div>
                        <div class="snTag">RTA: {{Request?.id}}</div>
                    </div>
                </ng-template>
                <kendo-gridlayout [cols]="[210, 375, 155]">
                    <kendo-gridlayout-item [col]="1" [row]="1">
                        <img src="assets/images/logos/logo.png" style="width:100%" />
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="2" [row]="1">
                        <h1 style="width: 100%; vertical-align: middle; text-align: center;">Request Details</h1>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="3" [row]="1">
                    </kendo-gridlayout-item>
                </kendo-gridlayout>
                <kendo-gridlayout>
                    <kendo-gridlayout-item [col]="1" [colSpan]="8" [row]="1" class="tblTitle">Region</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="9" [colSpan]="8" [row]="1" class="tblTitle">Submitted
                        By</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="5" [row]="1" class="tblTitle">Requested
                        By</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="22" [colSpan]="3" [row]="1"
                        class="tblTitle">Priority</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="8" [row]="2"
                        class="tblContent">{{Request?.nwA_Application?.applicationName}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="9" [colSpan]="8" [row]="2"
                        class="tblContent">{{Request?.submittedByUser?.displayName}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="5" [row]="2"
                        class="tblContent">{{Request?.requiredDate | date: "MMM dd yyyy"}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="22" [colSpan]="3" [row]="2"
                        class="tblContent">{{Priority}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="6" [row]="3" class="tblTitle">Subpsl /
                        Productline</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="7" [colSpan]="6" [row]="3"
                        class="tblTitle">Reference</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="13" [colSpan]="4" [row]="3" class="tblTitle">CDT
                        Required</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="4" [row]="3" class="tblTitle">Request
                        Type</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="21" [colSpan]="4" [row]="3" class="tblTitle">Excl</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="6" [row]="4"
                        class="tblContent">{{Request?.subPsls?.name}} /
                        {{Request?.productLines?.name}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="7" [colSpan]="6" [row]="4"
                        class="tblContent">{{ReferenceNumber}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="13" [colSpan]="4" [row]="4"
                        class="tblContent">{{CentralDesignRequired}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="4" [row]="4"
                        class="tblContent">{{Request?.type?.name}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="21" [colSpan]="4" [row]="4"
                        class="tblContent">{{ExclusionRequest}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="5" class="tblTitle">Notes to
                        Designer</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="6" [rowSpan]="5" class="tblContentTextArea">
                        <div class="k-editor-content" dir="ltr">
                            <div [innerHTML]="Request?.notesToDesignSupport"></div>
                        </div>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="11"
                        class="tblTitle">Description</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="12" [rowSpan]="5" class="tblContentTextArea">
                        <div class="k-editor-content" dir="ltr">
                            <div [innerHTML]="Request?.description"></div>
                        </div>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="17" class="tblTitle">Difference from
                        Reference</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="18"
                        class="tblContentTextArea">{{Request?.difference}}</kendo-gridlayout-item>
                </kendo-gridlayout>
                <kendo-gridlayout style="padding-top: 10px;" class="cogs-table" *ngIf="!isEjdf">
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="1" class="tblTitleCoGs"></kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="1"
                        class="tblTitleCoGs">Reference</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="1"
                        class="tblTitleCoGs">RTA</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="1"
                        class="tblTitleCoGs">Delta</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="2"
                        class="tblTitleGroup">Cutters</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="3" class="tblContent">Primary
                        Cutters</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="3"
                        class="tblContent">${{formatTo(cogs.Ref_PrimaryCutter)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="3"
                        class="tblContent">${{formatTo(cogs.Rta_PrimaryCutter)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="3"
                        class="tblContent {{getCogsDeltaColor(cogs.Rta_PrimaryCutter,cogs.Ref_PrimaryCutter)}}">{{getCogDelta(+cogs.Rta_PrimaryCutter,+cogs.Ref_PrimaryCutter)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="4" class="tblContent">Backup
                        Elements</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="4"
                        class="tblContent">${{formatTo(cogs.Ref_BackupElement)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="4"
                        class="tblContent">${{formatTo(cogs.Rta_BackupElement)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="4"
                        class="tblContent {{getCogsDeltaColor(cogs.Rta_BackupElement,cogs.Ref_BackupElement)}}">{{getCogDelta(+cogs.Rta_BackupElement,+cogs.Ref_BackupElement)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="5" class="tblTitleGroup">Body Materials
                        ({{Request?.productLines?.name}})</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="6"
                        class="tblContent">Powder</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="6"
                        class="tblContent">${{formatTo(cogs.Ref_Powder)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="6"
                        class="tblContent">${{formatTo(cogs.Rta_Powder)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="6"
                        class="tblContent {{getCogsDeltaColor(cogs.Rta_Powder,cogs.Ref_Powder)}}">{{getCogDelta(+cogs.Rta_Powder,+cogs.Ref_Powder)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="7"
                        class="tblContent">Binder</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="7"
                        class="tblContent">${{formatTo(cogs.Ref_Binder)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="7"
                        class="tblContent">${{formatTo(cogs.Rta_Binder)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="7"
                        class="tblContent {{getCogsDeltaColor(cogs.Rta_Binder,cogs.Ref_Binder)}}">{{getCogDelta(+cogs.Rta_Binder,+cogs.Ref_Binder)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="8" class="tblContent">Hard
                        Facing</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="8"
                        class="tblContent">${{formatTo(cogs.Ref_Hardfacing)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="8"
                        class="tblContent">${{formatTo(cogs.Rta_Hardfacing)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="8"
                        class="tblContent {{getCogsDeltaColor(cogs.Rta_Hardfacing,cogs.Ref_Hardfacing)}}">{{getCogDelta(+cogs.Rta_Hardfacing,+cogs.Ref_Hardfacing)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="9" class="tblContent">Matrix to
                        Steel</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="9" class="tblContent"></kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="9" class="tblContent"></kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="9"
                        class="tblContent">${{formatTo(cogs.Delta_Matrix2Steel)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="10"
                        class="tblTitleGroup">Connection</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="10" [row]="11" class="tblContent">Upper
                        Section</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="6" [row]="11"
                        class="tblContent">${{formatTo(cogs.Ref_Uppersection)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="6" [row]="11"
                        class="tblContent">${{formatTo(cogs.Rta_Uppersection)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="11"
                        class="tblContent">{{getCogDelta(+cogs.Rta_Uppersection, +cogs.Ref_Uppersection)}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="22" [row]="12">
                        <div style="text-align: right; width: 100%;"><span
                                class="total-savings-label">Total Estimated Savings</span>
                        </div>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="12">
                        <div style="text-align: center; width: 100%;"><span
                                class="total-savings-value {{getTotalSavingsClass(cogs.Total_Savings)}}">
                                ${{formatTo(cogs.Total_Savings)}}</span></div>
                    </kendo-gridlayout-item>
                </kendo-gridlayout>
                <!-- Cutter Summary Section -->
                <div class="cutter-summary-section" *ngIf="cutterQuantitiesList.length > 0">
                    <div class="tblTitleGroup">
                        Cutter Summary ({{getTotalCutterCount()}} Total)
                    </div>
                    <div class="cutter-quantities-grid">
                        <div *ngFor="let item of cutterQuantitiesList"
                             class="cutter-quantity-item">
                            <span class="cutter-color-indicator"
                                  [style.background-color]="getColorByIndex(item.index)"></span>
                            <span class="cutter-name">
                                {{item.cutter.name}}
                            </span>
                            <span class="cutter-chamfer">
                                ({{item.cutter.cutterChamfer}})
                            </span>
                            <span class="cutter-qty">
                                x{{item.qty}}
                            </span>
                        </div>
                    </div>
                </div>
                <kendo-gridlayout style="padding-top: 10px;">
                    <kendo-gridlayout-item [col]="1" [colSpan]="24" [row]="1" [rowSpan]="2" class="tblTitleRequest">Request
                        Requirements</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="3" [row]="3" class="tblTitle">Size</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="4" [colSpan]="3" [row]="3" class="tblTitle">Core
                        Size</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="7" [colSpan]="4" [row]="3"
                        class="tblTitle">Nomenclature</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="2" [row]="3" class="tblTitle">Level</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="13" [colSpan]="2" [row]="3"
                        class="tblTitle">Retrofit</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="15" [colSpan]="3" [row]="3" class="tblTitle">Gauge
                        Length</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="18" [colSpan]="3" [row]="3"
                        class="tblTitle">w/Sleeve</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="21" [colSpan]="4" [row]="3" class="tblTitle">One
                        Piece</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="3" [row]="4"
                        class="tblContent">{{Request?.bit?.size}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="4" [colSpan]="3" [row]="4"
                        class="tblContent">{{Request?.bit?.coreSize}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="7" [colSpan]="4" [row]="4"
                        class="tblContent">{{Request?.bit?.type}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="2" [row]="4"
                        class="tblContent">{{Request?.bit?.level}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="13" [colSpan]="2" [row]="4"
                        class="tblContent">{{Retrofit}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="15" [colSpan]="3" [row]="4"
                        class="tblContent">{{Request?.bit?.gaugeLength}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="18" [colSpan]="3" [row]="4"
                        class="tblContent">{{HasSleeve}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="21" [colSpan]="4" [row]="4"
                        class="tblContent">{{OnePiece}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="5" [row]="5" class="tblTitle">Body
                        Hardfacing</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="6" [colSpan]="5" [row]="5" class="tblTitle">Oculus
                        Influenced</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="5" [row]="5" class="tblTitle">Cerebro
                        Influenced</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="16" [colSpan]="5" [row]="5" class="tblTitle">API</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="21" [colSpan]="2" [row]="5"
                        class="tblTitle">Restrictor</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="5"
                        class="tblTitle">ShortShank</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="5" [row]="6"
                        class="tblContent">{{Request?.bit?.hardfacing}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="6" [colSpan]="5" [row]="6"
                        class="tblContent">{{OculusInfluenced}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="11" [colSpan]="5" [row]="6"
                        class="tblContent">{{CerebroInfluenced}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="16" [colSpan]="5" [row]="6"
                        class="tblContent">{{Request?.uppersection?.apiSize}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="21" [colSpan]="2" [row]="6"
                        class="tblContent">{{Restrictor}}</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="23" [colSpan]="2" [row]="6"
                        class="tblContent">{{ShortShank}}</kendo-gridlayout-item>
                </kendo-gridlayout>
                <kendo-gridlayout>
                    <kendo-gridlayout-item [col]="1" [colSpan]="16" [row]="1" class="tblTitle">Gauge
                        Exposure</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="8" [row]="1" class="tblTitle">Gauge
                        Protection</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="1" [colSpan]="16" [row]="2" [rowSpan]="7" class="tblContent">
                        <div #surface style="max-width: 90%;"></div>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="8" [row]="2" [rowSpan]="3" class="tblContentList">
                        <div *ngFor="let protection of Request?.gaugeProtections"><span
                                class="k-icon k-font-icon k-i-circle"></span>{{protection.protection}}</div>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="8" [row]="5" [rowSpan]="1"
                        class="tblTitle">Powders/Binder</kendo-gridlayout-item>
                    <kendo-gridlayout-item [col]="17" [colSpan]="8" [row]="6" [rowSpan]="3" class="tblContentList">
                        <div *ngFor="let powder of Request?.powders"><span
                                class="k-icon k-font-icon k-i-circle"></span>{{powder.location}} - {{powder.type}}</div>
                    </kendo-gridlayout-item>
                </kendo-gridlayout>
            </div>
        </kendo-pdf-export>
    </div>
</div>
